import React from "react"

import { FEATURES_TYPE, REAL_TIME_ROUTES } from "@constants"
import AppLayout from "Layout"
import RealTimePage from "./RealTime"
import HistoryPage from "./History"
import { Navigate } from 'react-router-dom'


export const RealTimeRoutes = {
	id: FEATURES_TYPE.COMMON,
	path: REAL_TIME_ROUTES.PATH,
	title: REAL_TIME_ROUTES.TITLE,
	icon: 'search',
	element: <AppLayout/>,
	children: [{
		element: <Navigate to={REAL_TIME_ROUTES.SEARCHES_PATH} replace/>,
		index: true,
	}, {
		path: REAL_TIME_ROUTES.SEARCHES_PATH,
		title: REAL_TIME_ROUTES.TITLE,
		element: <RealTimePage/>
	}, {
		path: REAL_TIME_ROUTES.HISTORY_PATH,
		title: REAL_TIME_ROUTES.HISTORY_TITLE,
		element: <HistoryPage/>
	}],
	tooltip: "Real Time Searches",
}